import { render } from "./TargetTerm.vue?vue&type=template&id=607b47a4"
import script from "./TargetTerm.vue?vue&type=script&lang=js"
export * from "./TargetTerm.vue?vue&type=script&lang=js"

import exportComponent from "/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__